module.exports = __webpack_public_path__ + "img/J12324.906c234e.png";